import Vue from 'vue';
import VueNotifications from 'vue-notification';

Vue.use(VueNotifications);

export type NotifySuccess = (message: string) => void;
export type NotifyError = (message: string) => void;

// success
const notifySuccess: NotifySuccess = (message: string) => {
  Vue.notify({
    type: 'success',
    title: message,
    duration: 2000,
  });
};
Vue.prototype.$notifySuccess = notifySuccess;

// error
const notifyError: NotifyError = (message: string) => {
  Vue.notify({
    type: 'error',
    title: message,
    duration: 2000,
  });
};
Vue.prototype.$notifyError = notifyError;

// FIXME define types
(window as any).$notifySuccess = Vue.prototype.$notifySuccess;
(window as any).$notifyError = Vue.prototype.$notifyError;
